const removeDemoDataFromId = (id: string) => {
  return id.replace(/(?:demo-|demodata-)/g, '');
};

const addDemoPrefix = (id: string) => {
  return checkIsDemoId(id) ? id : `demo-${id}`;
};

const checkIsDemoId = (id: string) => {
  return id.startsWith('demo-') || id.startsWith('demodata-');
};

export const DemoIdUtils = {
  removeDemoDataFromId,
  addDemoPrefix,
  checkIsDemoId,
};
